import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Divider,
  Grid,
  Hidden,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
// import { CarouselProvider, Slider, Slide } from "pure-react-carousel";

import LogoItem from "./LogoLinkItem";
import TitleContainer from "./TitleContainer";
import UseMobile from "../../hooks/useIsMobile";

// import Carousel from "@brainhubeu/react-carousel";
// import "@brainhubeu/react-carousel/lib/style.css";
import LayoutContainer from "../../components/LayoutsContainer";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";

import Slider from "react-slick";
import AliceCarousel from "react-alice-carousel";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.lightGray,
    [theme.breakpoints.between("sm", "xs")]: {
      marginTop: theme.spacing(2),
      // backgroundColor: "white",
      height: "auto",
      paddingBottom: theme.spacing(2),
    },
  },
  Divider: {
    marginBottom: theme.spacing(5),
  },
  titleContainer: {
    [theme.breakpoints.between("sm", "xs")]: {
      // backgroundColor: "yellow",
    },
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2rem",
    color: "white",
    backgroundColor: theme.palette.primary.main,
    // awidth: "20%",
    // width: "15%",
    textAlign: "center",
    padding: 10,
    // padding: "10 30px",
    // wordWrap: "no-wrap",
  },
  personalityContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  CarouselProvider: {
    marginTop: theme.spacing(5),

    [theme.breakpoints.down("sm")]: {
      marginTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
    },
  },
  btns: {
    backgroundColor: "transparent",
    border: "none",
  },
  gridContainer: {
    [theme.breakpoints.between("sm", "xs")]: {
      // backgroundColor: "red",
    },
  },
}));

const PortFolio = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  const [value, setValue] = React.useState(0);
  const onChange = (e) => {
    setValue(e);
  };

  const SliderItems = data?.data?.map((item, index) => {
    return <LogoItem data={item} key={index} />;
  });
  var settings = {
    slidesToShow: isMobile ? 2 : 6,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,

    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    draggable: false,
  };
  return (
    <>
      <div className={classes.root}>
        <LayoutContainer>
          <MobileHidden>
            <div className={classes.Divider}>
              <Divider />
            </div>
          </MobileHidden>

          <Grid container>
            <Grid item lg={10} sm={12} xs={12}>
              {data.title && (
                <>
                  <MobileHidden>
                    <Grid container className={classes.gridContainer}>
                      <Grid item className={classes.titleContainer}>
                        <TitleContainer title={data.title} />
                      </Grid>
                    </Grid>
                  </MobileHidden>
                  <DesktopHidden>
                    <Grid
                      container
                      justify="center"
                      className={classes.gridContainer}
                    >
                      <Grid item className={classes.titleContainer}>
                        <TitleContainer title={data.title} />
                      </Grid>
                    </Grid>
                  </DesktopHidden>
                </>
              )}
            </Grid>
            {/* <Grid
                item
                lg={2}
                justify="space-evenly"
                alignItems="center"
                container
              >
                <Grid item>
                  <ButtonBack className={classes.btns}>
                    <CarouselBtn type="back" />
                  </ButtonBack>
                </Grid>
                <Grid item>
                  <ButtonNext className={classes.btns}>
                    <CarouselBtn type="next" />
                  </ButtonNext>

                </Grid>
              </Grid> */}
          </Grid>

          <div className={classes.CarouselProvider}>
            <AliceCarousel
              autoPlay={data?.data?.length > 4}
              disableButtonsControls
              disableDotsControls
              infinite
              autoPlayInterval={3000}
              mouseTracking
              items={SliderItems}
              responsive={{
                0: {
                  items: 3,
                },

                600: {
                  items: 4,
                  autoPlayInterval: 5000,
                },
                500: {
                  items: 2,
                  autoPlayInterval: 5000,
                },
                200: {
                  items: 2,
                  autoPlayInterval: 5000,
                },
                960: {
                  items: 4,
                  autoPlayInterval: 5000,
                },
                1280: {
                  items: 4,
                  autoPlayInterval: 5000,
                },
              }}
            />
            {/* <Slider {...settings}>{SliderItems}</Slider> */}

            {/* {data?.data?.map((man, index) => {
                  return (
                    <Slide index={index} key={index}>
                      <LogoItem data={man} />
                    </Slide>
                  );
                })}
                 </Carousel> */}
            {/* <Slide index={0}>I am the first Slide.</Slide>
              <Slide index={1}>I am the second Slide.</Slide>
              <Slide index={2}>I am the third Slide.</Slide>
              <Slide index={2}>I am the third Slide.</Slide>
              <Slide index={2}>I am the third Slide.</Slide> */}
          </div>
        </LayoutContainer>
      </div>
    </>
  );
};
export default PortFolio;
